// CategoryFeeSelectWithCreation.js
import React, { useState, useEffect } from 'react';
import {
    TextField, FormControl, Autocomplete, CircularProgress, createFilterOptions
} from '@mui/material';
import { getCondoId } from '../../../services/Main/AuthStorage';
import { api } from '../../../services/Main/Api';

const filter = createFilterOptions();

const CategoryFeeSelectWithCreation = ({ category, setCategory, categoryChoices, setCategoryChoices, ...props }) => {
    const [inputValue, setInputValue] = useState('');
    const [creating, setCreating] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState(categoryChoices || []);

    useEffect(() => {
        setOptions(categoryChoices);
    }, [categoryChoices]);

    const fetchCategories = async (search) => {
        setFetching(true);
        try {
            const res = await api.get('/category-fee/', {
                params: {
                    search,
                    company: getCondoId()
                }
            });
            if (Array.isArray(res.data?.results)) {
                setOptions(res.data.results.map(item => ({
                    id: item.id,
                    value: item.title,

                })));
            }
        } catch (err) {
            console.error('Erro ao buscar categorias:', err);
        } finally {
            setFetching(false);
        }
    };

    const handleCreateCategory = async (title) => {
        if (!title.trim()) return;
        setCreating(true);
        const payload = {
            title,
            company: getCondoId(),
            tag: title.toUpperCase().replace(/\s+/g, '-')
        };
        try {
            const res = await api.post('/category-fee/', payload);
            const newCategory = {
                id: res.data.id,
                value: res.data.title,
                rules: {
                    invoice_rule: 'NO_ACTION',
                    transfer_rule: 'NO_ACTION',
                    recurring: false,
                    payment: false,
                },
            };
            setCategoryChoices((prev) => [...prev, newCategory]);
            setCategory(newCategory.id);
        } catch (err) {
            console.error('Erro ao criar categoria:', err);
        } finally {
            setCreating(false);
        }
    };

    const handleChange = (event, newValue) => {
        if (typeof newValue === 'string') {
            handleCreateCategory(newValue);
        } else if (newValue && newValue.inputValue) {
            handleCreateCategory(newValue.inputValue);
        } else if (newValue && newValue.id) {
            setCategory(newValue.id);
        } else {
            setCategory('');
        }
    };

    const selectedOption = categoryChoices.find((item) => item.id === category) || null;

    return (
        <FormControl fullWidth required>
            <Autocomplete
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                value={selectedOption}
                onChange={handleChange}
                inputValue={inputValue}
                onInputChange={(event, newInputValue, reason) => {
                    setInputValue(newInputValue);
                    if (reason === 'input') {
                        fetchCategories(newInputValue);
                    }
                }}
                options={options}
                getOptionLabel={(option) => {
                    if (typeof option === 'string') return option;
                    if (option.inputValue) return option.inputValue;
                    return option.value || '';
                }}
                filterOptions={(opts, params) => {
                    const filtered = filter(opts, params);
                    const isExisting = opts.some((opt) => params.inputValue === opt.value);
                    if (params.inputValue !== '' && !isExisting) {
                        filtered.push({ inputValue: params.inputValue, value: `Adicionar "${params.inputValue}"` });
                    }
                    return filtered;
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                loading={creating || fetching}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Categoria"
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {(creating || fetching) ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
                {...props}
            />
        </FormControl>
    );
};

export default CategoryFeeSelectWithCreation;
